import {
	createRouter,
	createWebHashHistory
} from 'vue-router'

export const routes = [{
		path: "/login",
		name: 'login',
		meta: {
			notoken: true
		},
		component: () => import('@/views/login/login.vue')
	},
	{
		path: "/password",
		name: 'password',
		meta: {
			notoken: true
		},
		notoken: true,
		component: () => import('@/views/login/password.vue')
	},
	{
		path: "/",
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: '/databoard',
				name: 'databoard',
				component: () => import('@/views/databoard.vue'),
				meta: {
					titL: ['数据台'],
					tab: '/databoard',
				},
			},
		]
	},
	{
		path: "/",
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: '/user/list',
				name: 'user/list',
				component: () => import('@/views/user/list.vue'),
				meta: {
					titL: ['用户列表'],
					tab: '/user/list',
				},
			},
			{
				path: '/user/:userId',
				name: 'user/userId',
				component: () => import('@/views/user/userId.vue'),
				meta: {
					titL: ['用户详情'],
					tab: '/user/list',
				},
			},
			{
				path: '/user/sell',
				name: 'user/sell',
				component: () => import('@/views/user/sell.vue'),
				meta: {
					titL: ['销售员列表'],
					tab: '/user/sell',
				},
			},
			{
				path: '/user/sell/:userId',
				name: 'user/sellId',
				component: () => import('@/views/user/sellId.vue'),
				meta: {
					titL: ['销售员列表'],
					tab: '/user/sell',
				},
			},
		]
	},
	{
		path: "/",
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: '/service/list',
				name: 'service/list',
				component: () => import('@/views/service/list.vue'),
				meta: {
					titL: ['服务列表'],
					tab: '/service/list',
				},
			},
			{
				path: '/service/type',
				name: 'service/type',
				component: () => import('@/views/service/type.vue'),
				meta: {
					titL: ['分类管理'],
					tab: '/service/type',
				},
			},
			{
				path: '/service/template',
				name: 'service/template',
				component: () => import('@/views/service/template.vue'),
				meta: {
					titL: ['折扣模板'],
					tab: '/service/template',
				},
			},
			{
				path: '/service/Id/:id',
				name: 'service/Id',
				component: () => import('@/views/service/Id.vue'),
				meta: {
					titL: ['服务详情'],
					tab: '/service/list',
				},
			},
		]
	},
	{
		path: "/",
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/appoint/storeorder",
				name: 'appoint/storeorder',
				component: () => import('@/views/appoint/storeorder.vue'),
				meta: {
					titL: ['到店订单'],
					tab: '/appoint/storeorder',
				},
			},
			{
				path: "/appoint/orderdetail/:orderId",
				name: 'appoint/orderdetail',
				component: () => import('@/views/appoint/orderdetail.vue'),
				meta: {
					titL: ['预约订单详情'],
					tab: '/appoint/storeorder',
				},
			},
			{
				path: "/appoint/serviceorder",
				name: 'appoint/serviceorder',
				component: () => import('@/views/appoint/serviceorder.vue'),
				meta: {
					titL: ['上门订单'],
					tab: '/appoint/serviceorder',
				},
			},
			{
				path: '/appoint/evaluate',
				name: 'appoint/evaluate',
				component: () => import('@/views/appoint/evaluate.vue'),
				meta: {
					titL: ['服务评价'],
					tab: '/appoint/evaluate',
				},
			},
			{
				path: '/appoint/paySet',
				name: 'appoint/paySet',
				component: () => import('@/views/appoint/paySet.vue'),
				meta: {
					titL: ['支付时间设置'],
					tab: '/appoint/paySet',
				},

			}
		]
	},
	{
		path: "/",
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/store/list",
				name: 'store/list',
				component: () => import('@/views/store/list.vue'),
				meta: {
					titL: ['门店列表'],
					tab: '/store/list',
				},
			},
			{
				path: "/store/:id",
				name: 'store',
				component: () => import('@/views/store/storeId.vue'),
				meta: {
					titL: ['门店详情'],
					tab: '/store/list',
				},
			},
			{
				path: "/store/couponlist",
				name: 'store/couponlist',
				component: () => import('@/views/store/couponlist.vue'),
				meta: {
					titL: ['门店优惠券管理'],
					tab: '/store/couponlist',
				},
			},
			{
				path: "/store/coupon/:id",
				name: 'coupon',
				component: () => import('@/views/store/couponId.vue'),
				meta: {
					titL: ['优惠券详情'],
					tab: '/store/couponlist',
				},
			},
			{
				path: "/store/couponadd",
				name: 'store/couponadd',
				component: () => import('@/views/store/couponadd.vue'),
				meta: {
					titL: ['添加优惠券'],
					tab: '/store/couponlist',
				},
			},
			{
				path: "/store/item",
				name: 'store/item',
				component: () => import('@/views/store/item.vue'),
				meta: {
					titL: ['商品管理'],
					tab: '/store/item',
				},
			},
			// {
			// 	path: "/store/order",
			// 	name: 'store/order',
			// 	component: () => import('@/views/store/order.vue'),
			// 	meta: {
			// 		titL: ['订单管理'],
			// 		tab: '/store/order',
			// 	},
			// },
			// {
			// 	path: "/store/orderdetail",
			// 	name: 'store/orderdetail',
			// 	component: () => import('@/views/store/orderdetail.vue'),
			// 	meta: {
			// 		titL: ['订单详情'],
			// 		tab: '/store/order',
			// 	},
			// },
			{
				path: "/store/refunddetail",
				name: 'store/refunddetail',
				component: () => import('@/views/store/refunddetail.vue'),
				meta: {
					titL: ['退款详情'],
					tab: '/store/order',
				},
			},
			{
				path: "/store/freight",
				name: 'store/freight',
				component: () => import('@/views/store/freight.vue'),
				meta: {
					titL: ['运费模版管理'],
					tab: '/store/freight',
				},
			},
		]
	},
	{
		path: "/",
		title: '健康师管理',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/health/list",
				name: 'health/list',
				component: () => import('@/views/health/list.vue'),
				meta: {
					titL: ['健康师列表'],
					tab: '/health/list',
				},
			},
			{
				path: "/health/:id",
				name: 'health',
				component: () => import('@/views/health/id.vue'),
				meta: {
					titL: ['健康师详情'],
					tab: '/health/list',
				},
			},
		]
	},
	{
		path: "/",
		title: '品牌商管理',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/planet/index",
				name: 'planet/index',
				component: () => import('@/views/planet/index.vue'),
				meta: {
					titL: ['品牌商列表'],
					tab: '/planet/index',
				},
			},
			{
				path: "/planet/add",
				name: 'planet/add',
				component: () => import('@/views/planet/add.vue'),
				meta: {
					titL: ['新增品牌商'],
					tab: '/planet/index',
				},
			},
			{
				path: "/planet/:id",
				name: 'planet',
				component: () => import('@/views/planet/id.vue'),
				meta: {
					titL: ['品牌商详情'],
					tab: '/planet/index',
				},
			},
		]
	},
	{
		path: "/",
		title: '积分中心',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/integral/order",
				name: 'integral/order',
				component: () => import('@/views/integral/order.vue'),
				meta: {
					titL: ['积分兑换订单'],
					tab: '/integral/order',
				},
			},
			{
				path: "/integral/order/:id",
				name: 'integral/orderId',
				component: () => import('@/views/integral/orderId.vue'),
				meta: {
					titL: ['订单详情'],
					tab: '/integral/order',
				},
			},
			{
				path: "/integral/good",
				name: 'integral/good',
				component: () => import('@/views/integral/good.vue'),
				meta: {
					titL: ['积分商品管理'],
					tab: '/integral/good',
				},
			},
			{
				path: "/integral/goodadd",
				name: 'integral/goodadd',
				component: () => import('@/views/integral/goodadd.vue'),
				meta: {
					titL: ['添加礼品'],
					tab: '/integral/good',
				},
			},
		]
	},
	{
		path: "/",
		title: '加盟合作',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/partner/list",
				name: 'partner/list',
				component: () => import('@/views/partner/list.vue'),
				meta: {
					titL: ['申请列表'],
					tab: '/partner/list',
				},
			},
			{
				path: "/partner/id/:id",
				name: 'partner/id',
				component: () => import('@/views/partner/id.vue'),
				meta: {
					titL: ['加盟合作详情'],
					tab: '/partner/list',
				},
			},
		]
	},
	{
		path: "/",
		title: '发票中心',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/invoice/list",
				name: 'invoice/list',
				component: () => import('@/views/invoice/list.vue'),
				meta: {
					titL: ['申请列表'],
					tab: '/invoice/list',
				},
			},
			{
				path: "/invoice/invoiceId",
				name: 'invoice/invoiceId',
				component: () => import('@/views/invoice/invoiceId.vue'),
				meta: {
					titL: ['发票详情'],
					tab: '/invoice/list',
				},
			},
		]
	},
	{
		path: "/",
		title: '充值卡列表',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/card/list",
				name: 'card/list',
				component: () => import('@/views/card/list.vue'),
				meta: {
					titL: ['申请列表'],
					tab: '/card/list',
				},
			},
			{
				path: "/card/add",
				name: 'card/add',
				component: () => import('@/views/card/add.vue'),
				meta: {
					titL: ['新增充值卡'],
					tab: '/card/list',
				},
			},
			{
				path: "/card/:batchId",
				name: 'card/batchId',
				component: () => import('@/views/card/cardId.vue'),
				meta: {
					titL: ['充值卡详情'],
					tab: '/card/list',
				},
			},
		]
	},
	{
		path: "/",
		title: '收支明细',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/finance/withdraw",
				name: 'finance/withdraw',
				component: () => import('@/views/finance/withdraw.vue'),
				meta: {
					titL: ['提现申请'],
					tab: '/finance/withdraw',
				},
			},
			{
				path: "/finance/bill",
				name: 'finance/bill',
				component: () => import('@/views/finance/bill.vue'),
				meta: {
					titL: ['财务明细'],
					tab: '/finance/bill',
				},
			},
			{
				path: "/finance/bill/:id",
				name: 'finance/billId',
				component: () => import('@/views/finance/billId.vue'),
				meta: {
					titL: ['明细详情'],
					tab: '/finance/bill',
				},
			},
			{
				path: "/finance/cityprice",
				name: 'finance/cityprice',
				component: () => import('@/views/finance/cityprice.vue'),
				meta: {
					titL: ['上门费用管理'],
					tab: '/finance/cityprice',
				},
			},
			{
				path: "/finance/shopdata",
				name: 'finance/shopdata',
				component: () => import('@/views/finance/shopdata.vue'),
				meta: {
					titL: ['门店数据'],
					tab: '/finance/shopdata',
				},
			},
			{
				path: "/finance/shopdata/:id",
				name: 'finance/shopdataId',
				component: () => import('@/views/finance/shopdataId.vue'),
				meta: {
					titL: ['明细详情'],
					tab: '/finance/shopdata',
				},
			},
		]
	},
	{
		path: "/",
		title: '消息通知',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/message/index",
				name: 'message/index',
				component: () => import('@/views/message/index.vue'),
				meta: {
					titL: ['消息列表'],
					tab: '/message/index',
				},
			},
			{
				path: "/message/service",
				name: 'message/service',
				component: () => import('@/views/message/service.vue'),
				meta: {
					titL: ['平台客服'],
					tab: '/message/index',
				},
			},
			{
				path: "/message/add",
				name: 'message/add',
				component: () => import('@/views/message/add.vue'),
				meta: {
					titL: ['发布消息'],
					tab: '/message/index',
				},
			},
		]
	},
	{
		path: "/",
		title: '商城管理',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/shop/order",
				name: 'shop/order',
				component: () => import('@/views/shop/order.vue'),
				meta: {
					titL: ['订单管理'],
					tab: '/shop/order',
				},
			},
			{
				path: "/shop/evaluate",
				name: 'shop/evaluate',
				component: () => import('@/views/shop/evaluate.vue'),
				meta: {
					titL: ['订单评价'],
					tab: '/shop/evaluate',
				},
			},
			{
				path: "/shop/order/:id",
				name: 'shop/orderId',
				component: () => import('@/views/shop/orderId.vue'),
				meta: {
					titL: ['订单详情'],
					tab: '/shop/order',
				},
			},
			{
				path: "/shop/refund/:id",
				name: 'shop/refund',
				component: () => import('@/views/shop/refundId.vue'),
				meta: {
					titL: ['订单详情'],
					tab: '/shop/order',
				},
			},
			{
				path: "/shop/goodlist",
				name: 'shop/goodlist',
				component: () => import('@/views/shop/goodlist.vue'),
				meta: {
					titL: ['商品管理'],
					tab: '/shop/goodlist',
				},
			},
			{
				path: "/shop/goodsId/:id",
				name: 'shop/goodsId',
				component: () => import('@/views/shop/goodsId.vue'),
				meta: {
					titL: ['商品详情'],
					tab: '/shop/goodlist',
				},
			},
			{
				path: "/shop/type",
				name: 'shop/type',
				component: () => import('@/views/shop/type.vue'),
				meta: {
					titL: ['分类管理'],
					tab: '/shop/type',
				},
			},
			{
				path: "/shop/spec",
				name: 'shop/spec',
				component: () => import('@/views/shop/spec.vue'),
				meta: {
					titL: ['规格管理'],
					tab: '/shop/spec',
				},
			},
			{
				path: "/shop/specedit/:id/:name",
				name: 'shop/specedit',
				component: () => import('@/views/shop/specedit.vue'),
				meta: {
					titL: ['规格详情'],
					tab: '/shop/specedit',
				},
			},
		]
	},
	{
		path: "/",
		title: '系统管理',
		component: () => import('@/components/navbar.vue'),
		children: [
			
			{
				path: "/system/bind",
				name: 'system/bind',
				component: () => import('@/views/system/bind.vue'),
				meta: {
					titL: ['手机换绑'],
					tab: '/system/bind',
				},
			},
			{
				path: "/system/password",
				name: 'system/password',
				component: () => import('@/views/system/password.vue'),
				meta: {
					titL: ['修改密码'],
					tab: '/system/password',
				},
			},
			{
				path: "/system/employee",
				name: 'system/employee',
				component: () => import('@/views/system/employee.vue'),
				meta: {
					titL: ['员工管理'],
					tab: '/system/employee',
				},
			},
			{
				path: "/system/professionlist",
				name: 'system/professionlist',
				component: () => import('@/views/system/professionlist.vue'),
				meta: {
					titL: ['行业管理'],
					tab: '/system/professionlist',
				},
			},
			{
				path: "/system/role",
				name: 'system/role',
				component: () => import('@/views/system/role.vue'),
				meta: {
					titL: ['角色权限管理'],
					tab: '/system/role',
				},
			},
			{
				path: "/system/log",
				name: 'system/log',
				component: () => import('@/views/system/log.vue'),
				meta: {
					titL: ['操作日志'],
					tab: '/system/log',
				},
			},
			// {
			// 	path: "/system/level",
			// 	name: 'system/level',
			// 	component: () => import('@/views/system/level.vue'),
			// 	meta: {
			// 		titL: ['会员等级管理'],
			// 		tab: '/system/level',
			// 	},
			// },
			{
				path: "/system/about",
				name: 'system/about',
				component: () => import('@/views/system/about.vue'),
				meta: {
					titL: ['关于我们信息'],
					tab: '/system/about',
				},
			},
			{
				path: "/system/feedback",
				name: 'system/feedback',
				component: () => import('@/views/system/feedback.vue'),
				meta: {
					titL: ['用户反馈'],
					tab: '/system/feedback',
				},
			},
			{
				path: "/system/feedbackId",
				name: 'system/feedbackId',
				component: () => import('@/views/system/feedbackId.vue'),
				meta: {
					titL: ['反馈详情'],
					tab: '/system/feedback',
				},
			},
			{
				path: "/system/articleadd",
				name: 'system/articleadd',
				component: () => import('@/views/system/articleadd.vue'),
				meta: {
					titL: ['添加文章'],
					tab: '/system/help',
				},
			},
			{
				path: "/system/help",
				name: 'system/help',
				component: () => import('@/views/system/help.vue'),
				meta: {
					titL: ['用户协议和帮助文档'],
					tab: '/system/help',
				},
			},
			{
				path: "/system/version",
				name: 'system/version',
				component: () => import('@/views/system/version.vue'),
				meta: {
					titL: ['版本管理'],
					tab: '/system/version',
				},
			},
			{
				path: "/system/account",
				name: 'system/account',
				component: () => import('@/views/system/account.vue'),
				meta: {
					titL: ['账号信息'],
					tab: '/system/account',
				},
			},
			{
				path: "/system/ad",
				name: 'system/ad',
				component: () => import('@/views/system/ad.vue'),
				meta: {
					titL: ['运营广告'],
					tab: '/system/ad',
				},
			},
			{
				path: "/system/vipsetting",
				name: 'system/vipsetting',
				component: () => import('@/views/system/vipsetting.vue'),
				meta: {
					titL: ['套餐管理'],
					tab: '/system/vipsetting',
				},
			},
			{
				path: "/system/promise",
				name: 'system/promise',
				component: () => import('@/views/system/promise.vue'),
				meta: {
					titL: ['迟到设置'],
					tab: '/system/promise',
				},
			},
		]
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

export default router